// migrated
export const isResponseSuccess = result => {
	return result && result.response && (result.response.status >= 200 || result.response.status < 300)
}
